/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerskindperson2Inputs */

const en_partnerskindperson2 = /** @type {(inputs: Partnerskindperson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person`)
};

const de_partnerskindperson2 = /** @type {(inputs: Partnerskindperson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person`)
};

/**
* | output |
* | --- |
* | "Person" |
*
* @param {Partnerskindperson2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerskindperson2 = /** @type {((inputs?: Partnerskindperson2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerskindperson2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerskindperson2(inputs)
	return de_partnerskindperson2(inputs)
});
export { partnerskindperson2 as "partnersKindPerson" }